import React, { useState } from 'react';
import {
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton,
    ModalBody, ModalFooter, Button, FormControl, FormLabel, Input,
    FormErrorMessage, useToast, Stack
} from '@chakra-ui/react';

const ForgotPasswordModal = ({ isOpen, onClose }) => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const toast = useToast();

    const handleSubmit = async () => {
        if (!email.includes('@')) {
            setError('Please enter a valid email address');
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/forgot-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email })
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.message || 'Request failed');

            toast({
                title: 'Email sent.',
                description: 'Password reset instructions sent to your inbox.',
                status: 'success',
                variant: 'left-accent',
                duration: 4000,
                isClosable: true
            });
            setEmail('');
            onClose();
        } catch (err) {
            toast({
                title: 'Error.',
                description: err.message,
                status: 'error',
                variant: 'left-accent',
                duration: 4000,
                isClosable: true
            });
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered size="md" zIndex={99999}>
            <ModalOverlay />
            <ModalContent p={6} bg="white" containerProps={{ zIndex: '99999' }}>
                <ModalHeader textAlign="center" fontWeight="bold">Forgot Password</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Stack spacing={4}>
                        <FormControl isInvalid={!!error}>
                            <FormLabel>Email</FormLabel>
                            <Input
                                type="email"
                                placeholder="you@example.com"
                                value={email}
                                onChange={(e) => {
                                    setEmail(e.target.value);
                                    setError('');
                                }}
                            />
                            {error && <FormErrorMessage>{error}</FormErrorMessage>}
                        </FormControl>
                    </Stack>
                </ModalBody>
                <ModalFooter>
                    <Button onClick={handleSubmit} variant="solid-green-btn" fontWeight={600}>
                        Send Reset Link
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default ForgotPasswordModal;
